import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=2171fe82&"
import script from "./Expense.vue?vue&type=script&lang=js&"
export * from "./Expense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports